import React from 'react';
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from 'react-router-dom';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.scss';
import config from 'devextreme/core/config';

dayjs.extend(updateLocale);
dayjs.updateLocale('en', { weekStart: 1 });

config({ licenseKey: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjA1MTlkZWQwLWViYzgtNGRiMy04OWFiLWYwZjNjYzYzNjA0NSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.JJKFsFemG5DgmsQkRcAKT1rugwTY6Im2zci5vfEJkPoiCe8gaKqrDai7ubFLZz/beJ971raS7oBiyQwEsKSMBn6xjMWwvdNNrH/cxmsF8sidkVau4iTVY5PJaOMPaPCypjGdgg==' });

(async () => {
	if (process.env.NODE_ENV !== 'production') {
		/* eslint-disable import/no-extraneous-dependencies */
		const axe = await import('@axe-core/react');
		const ReactDOM = await import('react-dom');

		await axe.default(React, ReactDOM, 1000);
	}
})().catch((error) => console.error(error));

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN as string,
	integrations: [
		new Sentry.BrowserTracing({
			// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
			tracePropagationTargets: [],
			routingInstrumentation: Sentry.reactRouterV6Instrumentation(
				React.useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes
			),
		}),
		new Sentry.Replay(),
	],
	// Performance Monitoring
	tracesSampleRate: 1.0,
	// Session Replay
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<Sentry.ErrorBoundary fallback={<p>an error has occurred</p>}>
			<App />
		</Sentry.ErrorBoundary>
	</React.StrictMode>
);
